import React from 'react';
import {FormattedMessage} from 'react-intl';

export default class FormRadioGroupField extends React.Component {
    static propTypes = {
        field: React.PropTypes.object.isRequired,
        name: React.PropTypes.string.isRequired,
        message: React.PropTypes.object.isRequired,
        options: React.PropTypes.array.isRequired
    };

    static renderHint(hint) {
        return (
            <div className="hint hint--error">
                <FormattedMessage {...hint}/>
            </div>
        );
    }

    constructor(props) {
        super(props);
    }

    render() {
        const {message, field, name, options} = this.props;

        const notRequiredLabelClass = 'login--form__label form__label';
        const rowClass = 'form__row';
        const labelClass = notRequiredLabelClass;

        const radioElements = [];
        for (let i = 0; i < options.length; i++) {
            const optionId = options[i].id;
            const optionName = options[i].name;

            radioElements.push(
                <label key={optionId} style={{paddingRight: '30px', cursor: 'pointer'}}>
                <input type="radio" name={name} value={optionId} checked={field.value == optionId}
                       onChange={field.onChange}
                       onBlur={field.onChange}/>
                <FormattedMessage {...optionName}/>
            </label>);
        }

        return (
            <div className={rowClass}>
                <label className={labelClass}>
                    <FormattedMessage {...message}/>
                </label>
                <div style={{paddingTop: '5px'}}>
                    {radioElements}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/registration/FormRadioGroupField.jsx